import { api } from './client'

export type Project = {
  id: number
  workspace_id: number
  key: string
  name: string
  description: string | null
  status: 'active' | 'archived' | 'closed'
  color: string | null
  lead_user_id: number | null
  lead_name: string | null
  lead_email: string | null
  dkbooks_project_id: number | null
  dkbooks_client_id: number | null
  next_story_number: number
  created_at: string
  updated_at: string
  epic_count?: number | null
  story_count?: number | null
  sprint_count?: number | null
}

export type ProjectLookup = {
  id: number
  key: string
  name: string
  color: string | null
}

export async function listProjects(): Promise<Project[]> {
  type Paged = { data: Project[]; meta: unknown }
  // Backend returns paginated envelope; api() unwraps `data`. Project list returns arrays directly inside `data`.
  const res = await api<Project[] | Paged>('/projects')
  return Array.isArray(res) ? res : (res as Paged).data
}

export async function getProject(id: number | string): Promise<Project> {
  return api<Project>(`/projects/${id}`)
}

export async function lookupProjects(): Promise<ProjectLookup[]> {
  return api<ProjectLookup[]>('/lookups/projects')
}

export type ProjectCreate = {
  name: string
  key: string
  description?: string | null
  color?: string | null
  lead_user_id?: number | null
  dkbooks_project_id?: number | null
  dkbooks_client_id?: number | null
}

export async function createProject(data: ProjectCreate): Promise<Project> {
  return api<Project>('/projects', { method: 'POST', body: data })
}

export type ProjectUpdate = {
  name?: string
  description?: string | null
  status?: 'active' | 'archived' | 'closed'
  color?: string | null
  lead_user_id?: number | null
  dkbooks_project_id?: number | null
  dkbooks_client_id?: number | null
}

export async function updateProject(id: number, patch: ProjectUpdate): Promise<Project> {
  return api<Project>(`/projects/${id}`, { method: 'PATCH', body: patch })
}
